export default "__VITE_PUBLIC_ASSET__d26a28d0__"